var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#delete_svg__vw6bti76ja)",
    fill: "#575D9B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.75H9.722V.583A.583.583 0 009.14 0H4.86a.583.583 0 00-.583.583V1.75H0v.583h1.858c0 .02-.002.039 0 .058l1.05 10.506c.063.626.59 1.103 1.22 1.103h5.745c.629 0 1.156-.477 1.219-1.103l1.05-10.506c.002-.02 0-.038 0-.058H14V1.75zM4.861.583H9.14V1.75H4.861V.583zm5.65 12.256a.64.64 0 01-.638.578H4.127a.64.64 0 01-.638-.578L2.439 2.333h9.123l-1.05 10.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.292 3.5h-.584v8.75h.584V3.5zm2.042-.02l-.583 8.75.582.04.583-8.751-.582-.039zm-4.668 0l-.582.04.583 8.75.582-.039-.583-8.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delete_svg__vw6bti76ja"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgDelete;